<section>
  <header *ngIf="header" [innerHTML]="header | translate"></header>
  <div *ngIf="description" class="section-hint" [innerHTML]="description | translate"></div>

  <ng-content></ng-content>
</section>
